import * as React from "react";
import {
  InputContainer,
  InputRowContainer,
  Label,
  InputComponent,
  Error,
  Instructions
} from "./input-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleNotch,
  faCheckCircle,
  faInfo
} from "@fortawesome/free-solid-svg-icons";
import InfoCircleIcon from "../icon/icons/info-circle-icon";
type Props = {
  type?: string;
  label?: string;
  placeholder?: string;
  name?: string;
  value?: string;
  onChange?: (e: any) => void;
  register?: any;
  onBlur?: (e: any) => void;
  disable?: boolean;
  star?: string;
  onKeyUp?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  min?: any;
  max?: any;
  id?: string;
  className?: string;
  pattern?: string;
  hClass?: string;
  error?: string;
  autoFocus?: boolean;
  defaultValue?: any;
  hideLabel?: boolean;
  isValid?: boolean;
  validating?: boolean;
  maxLength?: number;
  minLength?:number;
  required?: boolean;
  showInstructions?: boolean
  instructions?: string,
  instructionFailed?: boolean
};

export default function Input({
  type = "text",
  label,
  placeholder,
  name,
  value,
  onChange,
  register,
  onBlur,
  disable,
  onKeyUp,
  min,
  max,
  pattern,
  className,
  id,
  autoFocus,
  defaultValue,
  hideLabel,
  error,
  isValid,
  validating = false,
  maxLength,
  minLength,
  onKeyDown,
  required = false,
  showInstructions,
  instructions,
  instructionFailed
}: Props) {
  let numberProps = {};
  if (type === "number") {
    numberProps = {
      min: "0",
      step: "1",
      onInput: onInputChange,
    };
  }

  function onInputChange(e: any) {
    e.target.value = e.target.value.replace(/[^0-9]+/g, "");
  }
  return (
    <>
      <InputRowContainer className={className}>
        {label && <Label className={hideLabel ? "hide" : ""}>{label}</Label>}
        <InputContainer className={disable ? "non-editable" : ""}>
          <InputComponent
            type={"text"}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            ref={register}
            onBlur={onBlur}
            disabled={disable}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            min={min}
            max={max}
            pattern={pattern}
            id={id}
            className={className}
            autoFocus={autoFocus}
            defaultValue={defaultValue}
            maxLength={maxLength}
            minLength={minLength}
            required={required}
            {...numberProps}
          />
          {isValid && (
            <FontAwesomeIcon
              icon={faCheckCircle}
              color="#13BD38"
              size="sm"
              className="validation"
            />
          )}
          {validating && (
            <FontAwesomeIcon
              icon={faCircleNotch}
              color="#13BD38"
              size="sm"
              className="spinner"
              spin
            />
          )}
        </InputContainer>
        {error && <Error>{error}</Error>}
        {showInstructions && (
          <Instructions className={instructionFailed ? 'danger' : ''}>
            <div className="info-icon">
              <InfoCircleIcon />
            </div>
            <p>{instructions}</p>
          </Instructions>
        )}
      </InputRowContainer>
    </>
  );
}
